/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { CommonModule } from '@angular/common';
import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';

import { HorizontalSplitSeparatorComponent } from './horizontal-split-pane-separator.component';
import { HorizontalSplitPaneComponent } from './horizontal-split-pane.component';
import { VerticalSplitSeparatorComponent } from './vertical-split-pane-separator.component';
import { VerticalSplitPaneComponent } from './vertical-split-pane.component';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CoreMlsModule } from '@gh/core-mls';

@NgModule({
  imports: [
    CommonModule,
    MatIconModule,
    MatTooltipModule,
    CoreMlsModule,
  ],
  declarations: [
    HorizontalSplitPaneComponent,
    VerticalSplitPaneComponent,
    HorizontalSplitSeparatorComponent,
    VerticalSplitSeparatorComponent,
  ],
  exports: [HorizontalSplitPaneComponent, VerticalSplitPaneComponent],
  schemas: [ NO_ERRORS_SCHEMA ],
})
export class CoreUiExtSplitPaneModule {
}
